var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineCart',{attrs:{"id":"chart","options":_vm.options,"data":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }